export default __webpack_public_path__ + "media/images/raty/star-half-mono-2-236390800650832300ad424ab80b9104.png";